export function processWebsiteBasicInfo(res) {

    // console.log(res);
    const data = cleanupReponseData(res);
    if (!data) {return {}; }

    const displayCompanyName = data.company_short_name?.trim().length > 0 ? data.company_short_name : data.company_name;
    const vlogDisplayTitle = displayCompanyName?.trim().length == 0 ? "视频官网" : displayCompanyName?.trim() + "的视频官网";

    const logoUrl = data.company_logo.url ? data.company_logo.url : "";
    const longLogoUrl = data.long_logo.url ? data.long_logo.url : "";

    var domain = data.domain?.trim();
    domain = domain?.length > 0 ? domain : "";
    const websiteUrl = domain.length > 0 ? "http://" + domain : "";

     return {
        website_id: data.website_id,
        name: data.name ? data.name : "",
        domain: data.domain ? data.domain : "",
        websiteUrl: websiteUrl,
        keywords: "",
        description: "",
        slogan: data.slogan ? data.slogan : "",
        logoUrl: logoUrl,
        longLogoUrl: longLogoUrl,
        preferredLogoUrl : longLogoUrl?.length > 0 ? longLogoUrl : logoUrl,
        companyName: data.company_name ? data.company_name: "",
        companyShortName: data.company_short_name ? data.company_short_name : "",
        displayCompanyName : displayCompanyName,
        vlogDisplayTitle : vlogDisplayTitle,
        avatarLogoUrl: logoUrl,
    }
}

function cleanupReponseData(res, options = {}) {
	for (let prop in res) {
		let val = res[prop];
		if (validateResponseValue(prop, val, options)) {
			// next. and find if has children
			if (typeof val === "object") {
				cleanupReponseData(val, options);
			}
		} else {
			// console.log("will delete");
			// console.log(res[prop]);
			delete res[prop];
		}
	}
	return res;
}

function validateResponseValue(prop, val, options = {}) {
	// cleanup invalid no-image url
	// delete url/thumbnail= https://wei.ltd.com/assets/images/no-image.jpg

	if (options) {
		/* */
	}
	if (prop == "url" || prop == "thumbnail") {
		// if (val == "https://wei.ltd.com/assets/images/no-image.jpg") {
			if (val == 'https://wei.ltd.com/assets/images/no-image.jpg' || val == 'https://static.xcx.gw66.vip/assets/images/no-image.jpg') {
			return false;
		}
	}
	return true;
}
